import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { IRFQSupplierQuotation } from 'src/app/modules/pr-buyer/models';

@Component({
  selector: 'po-success',
  templateUrl: './po-success.component.html',
  styleUrls: ['./po-success.component.scss']
})
export class PoSuccessComponent implements OnInit {

  public title !: string;
  public onClose = new BehaviorSubject<any>({});

  public lineNumberQuotationMap !: Record<string, {rfq_supplier_quotation : IRFQSupplierQuotation}>;
  public prId !: number | undefined;

  constructor(public bsModalRef: BsModalRef, private _router : Router) { }

  ngOnInit(): void {
    console.log(this.lineNumberQuotationMap);
  }

  public trackPOProgress() : void {
    this._router.navigate([`/buyer/quality-evaluation-sheet/${this.prId}`]);
    this.onModalClose();
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

}
